import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

// Streamer deal-referral program applications
export const streamerDealList = (params = '') => Http.get(`/admin/streamer-deals${serialize(params)}`)
export const streamerDealApprove = id => Http.post(`/admin/streamer-deals/${id}/approve`)
export const streamerDealReject = (id, data = {}) => Http.post(`/admin/streamer-deals/${id}/reject`, data)

// Deal clicks / streamer commission reconciliation
export const dealClickList = (params = '') => Http.get(`/admin/deal-clicks${serialize(params)}`)
export const dealClickMarkConverted = (id, data) => Http.post(`/admin/deal-clicks/${id}/mark-converted`, data)
export const dealClickMarkNoSale = id => Http.post(`/admin/deal-clicks/${id}/mark-no-sale`)

// Reach tracking for the public broadcast (Telegram/Discord/WhatsApp) — see
// DealBroadcastClick on the backend. Aggregated per deal/day, not row-by-row
// like dealClickList above.
export const dealBroadcastClickList = (params = '') => Http.get(`/admin/deal-broadcast-clicks${serialize(params)}`)

// Live preview of deals:broadcast-new's next poll — not a persisted queue,
// see DealBroadcastQueueService's docblock on the backend.
export const dealsPendingBroadcasts = (params = '') => Http.get(`/admin/deals/pending-broadcasts${serialize(params)}`)
